import React, { useEffect, useState } from "react";

const REACT_APP_API = process.env.REACT_APP_API_URL || "";

function formatDate(value) {
  if (!value) return "—";
  return new Date(value.replace(" ", "T")).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * FicheHistorique — timeline des enregistrements d'une fiche (qui, quand,
 * statut à ce moment-là), le plus récent en premier (point plein).
 *
 * Props :
 *   - ficId   : identifiant de la fiche ; rien n'est chargé/affiché sans lui.
 *   - visible : affiche ou masque le composant (défaut: true). Permet de
 *               l'appeler depuis plusieurs emplacements sans que chaque
 *               appelant ait à conditionner son rendu lui-même ; quand
 *               `visible` est faux, l'historique n'est pas non plus chargé.
 */
export default function FicheHistorique({ ficId, visible = true }) {
  const [lignes, setLignes] = useState(null);

  useEffect(() => {
    if (!ficId || !visible) return;
    fetch(`${REACT_APP_API}/api/custom/fiche/${ficId}/historique`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => setLignes(Array.isArray(data) ? data : []))
      .catch((e) => console.error("Erreur chargement historique", e));
  }, [ficId, visible]);

  if (!visible || !ficId) return null;

  return (
    <div style={{ border: "1px solid #e2e8f0", padding: 20, background: "#fff" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
        <span className="titre-bloc" style={{ marginBottom: 0 }}>Historique</span>
        <span style={{ fontSize: 12, color: "#1d4ed8" }}>Du plus récent au plus ancien</span>
      </div>

      {lignes === null ? (
        <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>Chargement…</p>
      ) : lignes.length === 0 ? (
        <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>Aucun enregistrement tracé pour le moment.</p>
      ) : (
        <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
          {lignes.map((l, i) => {
            const qui = l.utilisateur || l.suggestionAuteur || "—";
            return (
              <li
                key={i}
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "flex-start",
                  padding: "10px 0",
                  borderTop: i > 0 ? "1px solid #f1f5f9" : "none",
                }}
              >
                <input
                  type="radio"
                  checked={i === 0}
                  readOnly
                  disabled
                  style={{ marginTop: 4, flexShrink: 0 }}
                  aria-hidden="true"
                />
                <div>
                  <div style={{ fontWeight: 700 }}>
                    {l.evenement || "—"}
                    {l.statut && <> - <span style={{ textTransform: "uppercase" }}>{l.statut}</span></>}
                  </div>
                  <div style={{ fontSize: 13, color: "#64748b" }}>
                    {formatDate(l.date)}, par <strong>{qui}</strong>.
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
